import { useState, useRef } from "react";
import { getRepliesForAdmin } from "../../apis";

const useReplies = () => {
  const scrollRef = useRef(null);
  const [repliesData, setRepliesData] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [hasScrolledInitially, setHasScrolledInitially] = useState(false);

  const fetchReplies = async ({ messageId, scrollToBottom = false } = {}) => {
    try {
      setIsLoading(true);
      const response = await getRepliesForAdmin(messageId, 1);
      const reversedData = response.data.data.reverse();

      setRepliesData(reversedData);
      setPagination({
        current_page: response.data.meta.current_page,
        last_page: response.data.meta.last_page,
      });

      if (scrollToBottom && scrollRef.current && !hasScrolledInitially) {
        setTimeout(() => {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
          setHasScrolledInitially(true);
        }, 100);
      }
      return {
        repliesData: reversedData,
        pagination: {
          current_page: response.data.meta.current_page,
          last_page: response.data.meta.last_page,
        },
      };
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    scrollRef,
    repliesData,
    pagination,
    isLoading,
    fetchReplies,
    setRepliesData,
    setPagination,
    setIsLoading,
  };
};

export default useReplies;
